// @flow
import * as React from 'react';
import cn from 'classnames';

// Types
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import { Button } from 'components/atoms/';

// Utils
import { formatPhoneNumber, rawPhoneNumber } from 'utils/string';

import './VerifyIdentity.scss';

export type Props = {
  email: string,
  phone: string,
  obfuscatedBy: string,
  appFlow: string,
  dealerCountryCode: string,
  onNextClick: (event: MouseEvent) => void,
  setEmail: (email: string) => void,
  setObfuscatedBy: (obfuscatedBy: string) => void,
  verifyIdentity: (phoneValue: string, emailValue: string) => Object,
  intl: IntlShape
};

type State = {
  formattedInputValue: string,
  inputValue: string,
  showAlert: boolean,
  isSubmitting: boolean
};

class VerifyIdentity extends React.Component<Props, State> {
  static block = 'verify-identity';

  constructor(props: Props) {
    super(props);
    (this: any).handleChange = this.handleChange.bind(this);
    (this: any).handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      formattedInputValue: '',
      inputValue: '',
      showAlert: false,
      isSubmitting: false
    };
  }

  handleChange(ev: Object) {
    const { dealerCountryCode, obfuscatedBy } = this.props;
    let inputValue;
    if (obfuscatedBy === 'email' || obfuscatedBy === 'licenseNumber') {
      inputValue = rawPhoneNumber(ev.target.value);
    } else {
      inputValue = ev.target.value;
    }
    this.setState({
      formattedInputValue: formatPhoneNumber(inputValue, dealerCountryCode),
      inputValue
    });
  }

  async handleSubmit(mouseEvent: Object) {
    const { inputValue } = this.state;
    const {
      onNextClick,
      verifyIdentity,
      obfuscatedBy,
      setEmail,
      setObfuscatedBy
    } = this.props;

    if (inputValue.length > 0) {
      this.setState({ isSubmitting: true });
      const emailValue = obfuscatedBy === 'phoneNumber' ? inputValue : '';
      const phoneValue =
        obfuscatedBy === 'email' ||
        obfuscatedBy === 'licenseNumber' ||
        obfuscatedBy === 'deeplink'
          ? inputValue
          : '';
      const data = await verifyIdentity(phoneValue, emailValue);
      const { verifyCustomer } = data;
      if (verifyCustomer) {
        if (obfuscatedBy === 'phoneNumber') {
          setEmail(inputValue);
          setObfuscatedBy('');
        }
        onNextClick(mouseEvent);
      }
      this.setState({
        showAlert: !verifyCustomer,
        isSubmitting: false
      });
    }
  }

  render() {
    const ns = VerifyIdentity.block;
    const { email, phone, obfuscatedBy, intl } = this.props;
    const {
      inputValue,
      formattedInputValue,
      showAlert,
      isSubmitting
    } = this.state;
    const disabled = inputValue.length < 1;
    const phoneNumberObfuscated = obfuscatedBy === 'phoneNumber';
    const labelClass = cn(`${ns}__label`, {
      [`${ns}__warning`]: showAlert
    });
    return (
      <div className={ns}>
        <h2 className={`${ns}__title`}>
          {intl.formatMessage({
            id: 'c8.verify.identity.title'
          })}
        </h2>
        <p className={labelClass}>
          {intl.formatMessage(
            { id: 'c8.verify.identity.please.use.phone.email' },
            { phoneOrEmail: phoneNumberObfuscated ? email : phone }
          )}
        </p>
        <div className={`${ns}__form`}>
          <input
            className={`text-field`}
            onChange={ev => this.handleChange(ev)}
            value={formattedInputValue}
            tabIndex={0}
            aria-label={intl.formatMessage({
              id: 'c8.aria.verify.identity.input',
              defaultMessage: 'Introduce phone or email'
            })}
          />
          {showAlert && (
            <div className={`${ns}__alert`}>
              {intl.formatMessage({
                id: phoneNumberObfuscated
                  ? 'c8.verify.identity.email.doesnt.match'
                  : 'c8.verify.identity.phone.doesnt.match'
              })}
            </div>
          )}
          <Button
            className={`${ns}__next-btn`}
            size="medium"
            disabled={disabled}
            type="Submit"
            onClick={this.handleSubmit}
          >
            <div className={`${ns}--search-button`}>
              {intl.formatMessage({ id: 'c8.footer.next' })}
              {isSubmitting && <div className="ld ld-ring ld-spin-fast" />}
            </div>
          </Button>
        </div>
      </div>
    );
  }
}

export default VerifyIdentity;



// WEBPACK FOOTER //
// ./src/components/pages/ConfirmationPage/CreateProfile/components/VerifyIdentity/VerifyIdentity.js